import dayjs from "dayjs";

export const formatDate = (year: number, monthIndex: number) =>
    dayjs(`${year}-${monthIndex + 1}-01`).format("YYYY-MM-DD");
